import React, { memo, useEffect, useState } from 'react'
import { ComponentProps } from './types'
import { Box, Card, CardContent, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import moment from 'moment';
import TradingViewChart from './TradingChart';
// import { baseURL } from '../../config/grafanaClient';
import { io, Socket } from 'socket.io-client';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { appendEnvironmentRiskScoreChartData } from '../../store/slices/mainDashboardSlice';
import BarChartLoader from './BarChartLoader';
import { baseURL } from '../../config/grafanaClient';

const socket: Socket = io(baseURL, {
    transports: ["websocket"], // Force WebSockets
    reconnection: true, // Enable automatic reconnection
    reconnectionAttempts: 5, // Try 5 times
    reconnectionDelay: 3000, // Wait 3 sec before retry

});
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

const EnvironmentRiskChart = ({ id, index, pin, pinComponentHandler, selectedValueFacility, facilityIds, locationIds, currentTenant, ...rest }: ComponentProps) => {
    const [activeRoomId, setActiveRoomId] = useState<string>();
    const [filterType, setFilterType] = useState("day");
    const dispatch = useAppDispatch();
    const [loader, setLoader] = useState(true);
    const loading = useAppSelector(store => store?.mainDashboard.environmentRiskScore?.loading);
    const { userData } = useAppSelector(store => store?.authReducer);

    useEffect(() => {
        if (!loading && loader) {
            setLoader(false);
        }
    }, [loading]);
    useEffect(() => {
        socket.on("connect", () => {
            console.log(`Connected to server with ID: ${socket.id}`);
        });
        socket.on("roomMessage", ({ sender, message }: { sender: string; message: any }) => {
            console.log(`sender: ${sender} `, message);
            dispatch(appendEnvironmentRiskScoreChartData({ ...message, recalculateScore: true }))
        });
        return () => {
            socket.disconnect();
        }
    }, []);
    const handleFilterChange = (_: React.MouseEvent<HTMLElement, MouseEvent>, value: string) => {
        setFilterType(value);
        console.log({ startDate: new Date(moment().subtract(1, "month").startOf('day').valueOf()), endDate: new Date(moment().endOf('day').valueOf()) });
    }

    /* socket */
    useEffect(() => {
        if (currentTenant?.tenantCode && (selectedValueFacility || userData?.group === 'admin')) {
            const roomId = selectedValueFacility || currentTenant?.tenantCode;
            if (roomId && roomId !== activeRoomId) {
                console.log("roomId1 ", roomId);
                if (activeRoomId) {
                    leaveRoom(activeRoomId);
                }
                joinRoom(roomId);
                setActiveRoomId(roomId);
            }
        }
    }, [currentTenant?.tenantCode, facilityIds, locationIds, userData?.group]);
    const joinRoom = (roomId: string) => {
        socket.emit("joinRoom", roomId);
    };
    const leaveRoom = (roomId: string) => {
        socket.emit("leaveRoom", roomId);
    }
    return (
        <Card sx={{
            borderRadius: "3px !important",
            border: "none",
            backgroundColor: "#fff !important",
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.1) !important",
            height: "100%",
            width: "100%"
        }}>
            <Box onClick={() => pinComponentHandler(id)} sx={{ position: 'absolute', display: 'flex', justifyContent: 'flex-end', right: 10, top: "15px", cursor: "pointer" }}>
                {pin ? <img src="./assets/images/pin-filled.png" alt="pin" width={15} /> : <img src="./assets/images/pin-outline.png" alt="pin" width={15} />}
            </Box>
            <CardContent sx={{ height: 450, }}>
                <Box className="title" {...(pin ? {} : rest)} sx={{ display: "flex", alignItems: 'center', paddingX: "1em", ":hover": (pin ? {} : { backgroundColor: "#f4f4f4", borderRadius: "10px", cursor: "grab", }) }} >
                    <Typography variant="h6" sx={{ fontWeight: 'bolder' }}>Environment Threshold Index</Typography>
                    <img src="./assets/images/live-streaming.gif" alt="live" width={30} style={{ marginBottom: '10px', marginLeft: "1rem" }} />
                </Box>
                <Box sx={{ paddingX: "1em", }}>
                    <ToggleButtonGroup
                        value={filterType}
                        exclusive
                        onChange={handleFilterChange}
                        size="small"
                        sx={{ display: "flex", gap: 2 }}
                    >
                        {/* <ToggleButton value="day" className={`filter-button ${filterType === 'day' && 'filter-button-color-black'}`}>Current Day</ToggleButton> */}
                        {/* <ToggleButton value="week" className={`filter-button ${filterType === 'week' && 'filter-button-color-black'}`}>1W</ToggleButton>
                        <ToggleButton value="month" className={`filter-button ${filterType === 'month' && 'filter-button-color-black'}`}>1M</ToggleButton>
                        <ToggleButton value="year" className={`filter-button ${filterType === 'year' && 'filter-button-color-black'}`}>1Y</ToggleButton>
                        <ToggleButton value="all" className={`filter-button ${filterType === 'all' && 'filter-button-color-black'}`}>ALL</ToggleButton> */}
                    </ToggleButtonGroup>
                </Box>
                {/* <Box style={{ width: '100%', height: '500px' }}>
                    <ReactApexChart options={options} series={state.series} type="candlestick" height={350} />
                </Box> */}
                {loader ?
                    <Box key={index} sx={{ paddingX: 3, pb: 4, alignContent: 'end', height: "100%", display: "flex", alignItems: "end", gap: "1px", justifyContent: 'center' }}>
                        <BarChartLoader size={8} />
                    </Box> :
                    <TradingViewChart />
                }
            </CardContent>
        </Card>
    )
}

export default memo(EnvironmentRiskChart);



